import { IconProps } from './IconProps';
export function ChevronRightIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9999 12L16 11.9999L15.2928 11.2999L15.2928 11.3L8.92893 4.99999L8.22183 5.69999L14.5857 12L8.22178 18.3L8.92889 19L15.2928 12.7L15.2929 12.7L16 12L15.9999 12Z"
                fill="#66182A"
            />
        </svg>
    );
}
